import { Steps } from '@/scopes/checkout/components/Steps'
import { buildUrlWithCurrentParams } from '@/scopes/checkout/domain/helpers/BuildUrlWithCurrentParams'
import { useGetStepsTabs } from '@/scopes/checkout/domain/hooks'
import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints'
import { useDecision } from '@optimizely/react-sdk'
import { tok } from '@sunwebgroup/ui-components'
import { Typography } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { styled } from 'styled-components'

const Wrapper = styled.div``

const StepText = styled(Typography)`
  text-align: center;
  color: ${tok('semantics_content_color')};
`

export function CheckoutProgress() {
  const { isLoading, activeStep, items } = useGetStepsTabs()
  const { isDesktopSm } = useBreakpoints()
  const [step2InReactDecision] = useDecision('id_405_checkout_2_react_wg')

  // TODO: Remove after AB Test id_405_checkout_2_react_wg
  const goToStep = (url: string) => {
    if (step2InReactDecision.enabled) {
      url = url.replace('/wintersport/bookingpages/', '/wintersport/bookingpage/')
    }

    return url
  }

  if (isLoading)
    return ''

  return (
    <Wrapper data-qa="checkout-progress">
      <Steps activeStepValue={activeStep}>
        {items.map((step, index) => (
          <Steps.Step
            key={index}
            disabled={step.disabled}
            value={step.text}
            completed={step.completed}
            link={step.url ? { href: `${goToStep(buildUrlWithCurrentParams(step.url))}` } : undefined}
          >
            {isDesktopSm && <StepText $variant="body-xs-regular-tight">{step.text}</StepText>}
          </Steps.Step>
        ))}
      </Steps>
    </Wrapper>
  )
}
